module.exports = __webpack_public_path__ + "static/media/hostify.873776e8.png";